import { Flex, Spinner, Text, useColorModeValue } from '@chakra-ui/react';

interface SectionPlaceholderProps {
  label: string;
  isLoading?: boolean;
}

const SectionPlaceholder = ({
  label,
  isLoading = false,
}: SectionPlaceholderProps) => {
  const labelColor = useColorModeValue('gray.400', 'gray.500');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.200');

  return (
    <Flex
      align="center"
      justify="center"
      minH="140px"
      borderRadius="md"
      border="1px dashed"
      borderColor={borderColor}
    >
      {isLoading ? (
        <Spinner size="md" thickness="3px" speed="0.65s" color={labelColor} />
      ) : (
        <Text color={labelColor} fontSize="sm">
          {label} WIP...
        </Text>
      )}
    </Flex>
  );
};

export default SectionPlaceholder;
